
import { Component, Vue } from 'vue-property-decorator';

@Component<SuitesPanel>({})
export default class SuitesPanel extends Vue {}
